import {apiCall} from "../../../common/apiActionHandler";
import axios from "axios";

export const getNewRegistrations = (pagination, sorting, callback) => async (dispatch, getState) => {
    const config = {
        url: `/api/sign_up/get_new_registrations`,
        params: {
            ...pagination,
            ...sorting
        }
    }

    apiCall("New registrations load successfully", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, dispatch, getState, false);
};
